var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_16913)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1969 10.8859C4.39801 11.0489 4.42887 11.3441 4.26584 11.5452L2.23914 14.0452C2.07611 14.2463 1.78093 14.2772 1.57982 14.1141C1.37872 13.9511 1.34786 13.6559 1.51089 13.4548L3.53758 10.9548C3.70061 10.7537 3.9958 10.7229 4.1969 10.8859ZM10.803 10.8859C11.0041 10.7229 11.2993 10.7537 11.4623 10.9548L13.4891 13.4548C13.6522 13.6559 13.6213 13.9511 13.4202 14.1141C13.2191 14.2772 12.9239 14.2463 12.7609 14.0452L10.7341 11.5452C10.5711 11.3441 10.6019 11.0489 10.803 10.8859Z",
    fill: "#21367F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92739 1.06231C5.03112 1.29951 4.92292 1.57588 4.68572 1.6796C3.44175 2.22358 2.38492 3.11763 1.64039 4.23741C1.49706 4.45299 1.2061 4.51156 0.990515 4.36822C0.774935 4.22488 0.716369 3.93392 0.859707 3.71834C1.70284 2.45026 2.89963 1.43742 4.3101 0.820637C4.5473 0.716913 4.82367 0.825114 4.92739 1.06231ZM10.0727 1.06231C10.1764 0.825114 10.4528 0.716913 10.69 0.820637C12.1005 1.43742 13.2973 2.45026 14.1404 3.71834C14.2837 3.93392 14.2252 4.22488 14.0096 4.36822C13.794 4.51156 13.503 4.45299 13.3597 4.23741C12.6152 3.11763 11.5583 2.22358 10.3144 1.6796C10.0772 1.57588 9.96898 1.29951 10.0727 1.06231Z",
    fill: "#21367F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.75C10.6066 13.75 13.125 11.2316 13.125 8.125C13.125 5.0184 10.6066 2.5 7.5 2.5C4.3934 2.5 1.875 5.0184 1.875 8.125C1.875 11.2316 4.3934 13.75 7.5 13.75ZM7.81219 5.60753C7.81219 5.37009 7.60233 5.17761 7.34344 5.17761C7.08456 5.17761 6.87469 5.37009 6.87469 5.60753V8.47367C6.87469 8.61742 6.95302 8.75165 7.08343 8.83139L8.95843 9.97784C9.17383 10.1095 9.46487 10.0562 9.60847 9.8586C9.75207 9.66104 9.69386 9.39412 9.47846 9.26241L7.81219 8.24358V5.60753Z",
    fill: "#21367F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_16913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueClock);
export default __webpack_public_path__ + "static/media/blue-clock.65d30f2440de6983d8d78a87e09c0d57.svg";
export { ForwardRef as ReactComponent };